<section class="main-content-wrapper" style="position: relative; height: 100%">
  <header id="headerId" class="main-header">
    <div class="container-fluid header-bg" style="height: 55px">
      <div
        *ngIf="!hideNavbar"
        class="row align-items-center justify-content-between"
        style="height: 100%"
      >
        <!-- Logo -->
        <div class="col-6 col-md-2">
          <div class="logo">
            <a *ngIf="loginButtonShow == '/Login'" [routerLink]="['/Home']">
              <!-- <img src="../../assets/images/logo.png" alt="logo" class="logo-width" /> -->
              <!-- <img
                src="{{ EmployeeProfileBaseUrl }}logo.png"
                alt="logo"
                class="logo-width"
              /> -->
            </a>
            <a
              *ngIf="
                loginButtonShow == '/Home' ||
                loginButtonShow == '/' ||
                loginButtonShow == '/index/page'
              "
            >
              <!-- <img src="../../assets/images/logo.png" alt="logo" class="logo-width" /> -->
              <img
                src="{{ EmployeeProfileBaseUrl }}logo.png"
                alt="logo"
                class="logo-width"
              />
            </a>
            <a
              *ngIf="
                loginButtonShow != '/Home' &&
                loginButtonShow != '/' &&
                loginButtonShow != '/Login' &&
                loginButtonShow != '/index/page'
              "
              [routerLink]="['/index/page']"
            >
              <!-- <img src="../../assets/images/logo.png" alt="logo" class="logo-width" /> -->
              <img
                src="{{ EmployeeProfileBaseUrl }}logo.png"
                alt="logo"
                class="logo-width"
              />
            </a>
          </div>
        </div>

        <!-- Greeting / Heading -->
        <div
          class="col-md-6 d-none d-md-block text-center"
          style="
            background: #fff;
            height: 100%;
            border-radius: 100px 0 100px 0;
            border-left: 20px solid #acc4d7;
            border-right: 20px solid #acc4d7;
          "
        >
          <h2 *ngIf="username" class="greeting-text mb-0">
            <span class="user-role">{{ CompanyName }}</span>
          </h2>
        </div>
        <!-- Profile / Actions -->
        <div class="navRight">
          <ng-container *ngIf="username; else loginButton">
            <app-chat-modal-sheet class="me-2"></app-chat-modal-sheet>
            <app-emi-calculator class="me-2"></app-emi-calculator>

            <div class="dropleft position-relative" (click)="toggleDropdown()">
              <a
                class="user-profile-wrapper d-flex align-items-center cursor-pointer"
              >
                <img
                  [src]="EmployeeProfileBaseUrl + ProfilePic"
                  (error)="ProfilePic = 'assets/images/default-user.png'"
                  class="user-avatar"
                  alt="User"
                />
                <span class="user-name ms-1">{{ FullName }}</span>
              </a>

              <div id="cont" class="dropdown-menu" [class.show]="dropdownOpen">
                <a class="dropdown-item" (click)="ChangePassword()">
                  <i class="fa fa-key me-2"></i> Change Password
                </a>
                <a class="dropdown-item" [routerLink]="['/UserLogout']">
                  <i class="fa fa-power-off me-2"></i> Logout
                </a>
              </div>
            </div>
          </ng-container>

          <ng-template #loginButton>
            <div class="loginContainer">
              <a
                *ngIf="
                  username == '' &&
                  (loginButtonShow == '/Home' || loginButtonShow == '/')
                "
                [routerLink]="['/Login']"
              >
                <button class="btn loginBtn btn-lg">Login</button>
              </a>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
    <!-- Sub heading for desktop -->
    <div
      class="col-md-12 d-none d-md-block text-center sub-head font-size-12"
      *ngIf="SUB_Heading"
    >
      <div class="blink_me">{{ SUB_Heading }}</div>
    </div>
  </header>

  <div class="common-div">
    <router-outlet></router-outlet>
  </div>

  <!-- <div
    class="row m-0 align-items-center text-align-center align-bottom footer"
    id="footerId"
  >
    <div class="col-md-4 p-1 copyright-text">
      © 2024
      <a href="http://finnaux.com" target="_blank"
        >Finnaaux Tech Solutions Pvt. Ltd.</a
      >
    </div>
    <div class="col-md-4 p-1 footer-links">
      <a href="#" class="footer-btn download-btn"> Download Utilities </a>
      <a
        href="https://www.rbi.org.in/scripts/BS_ViewNBFCNotification.aspx"
        target="_blank"
        class="footer-btn irb-btn"
      >
        RBI Circular <i class="fas fa-arrow-right"></i>
      </a>
    </div>
  </div> -->

  <div
    class="row d-flex m-0 col-md-12 justify-content-between align-items-center footer"
    id="footerId"
  >
    <div class="p-1 copyright-text">
      © 2024 Designed and Powered By
      <span
        ><a href="http://finnaux.com" target="_blank" style="color: #007bff">
          Finnaux Techsolutions Pvt. Ltd.
        </a></span
      >
      All Rights Reserved
    </div>
    <div class="p-1 footer-links">
      <span class="utility-dropdown" *ngIf="username != ''">
        <span class="dropdown-trigger" (click)="toggleUtilityDropdown()">
          <a href="javascript:void(0)"
            >Download Utilities <i class="fa fa-chevron-up"></i
          ></a>
        </span>

        <div class="dropdown-content drop-up" [class.show]="dropdownVisible">
          <a
            href="https://demo.finnaux.com/assets/app-release.apk"
            target="_blank"
            download="app-release.apk"
          >
            Download Mobile App
          </a>
          <a
            href="https://demo.finnaux.com/assets/FinnauxWeb.msi"
            target="_blank"
            download="FinnauxWeb.msi"
          >
            Download MAC Utility
          </a>
        </div>
      </span>

      <span class="footer-link">
        <a
          href="https://www.rbi.org.in/scripts/BS_ViewNBFCNotification.aspx"
          target="_blank"
          style="color: #007bff"
        >
          RBI Circular</a
        >
      </span>
      <span class="footer-link">
        <a href="javascript:void(0)">Contact Us</a>
      </span>
      <span class="footer-link">
        <a
          href="https://helpdesk.finnaux.com/#/Login"
          target="_blank"
          style="color: #007bff"
          >Support</a
        >
      </span>
    </div>
  </div>
</section>

<div
  class="modal fade in"
  id="ChangePasswordModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  data-backdrop="false"
  style="background-color: rgba(0, 0, 0, 0.5); overflow: auto"
>
  <form #ddf="ngForm" (ngSubmit)="onUpdateChangePassword()" novalidate>
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
        <div cdkDragHandle class="modal-header" style="padding: 10px">
          <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
            Change Password
          </h6>
          <button
            type="button"
            (click)="OnCloseChangePasswordModal()"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">
              <i class="far text-black fa-times-circle"></i>
            </span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row m-0">
            <div class="col-md-12 p-1">
              <span class="required-lable">Old Password</span>
              <input
                type="password"
                name="Old_Password "
                id="Old_Password "
                #refOld_Password="ngModel"
                required
                placeholder="Old Password"
                [ngClass]="{
                  'is-invalid': ddf.submitted && refOld_Password.invalid,
                  'alert-warning':
                    refOld_Password.invalid &&
                    (refOld_Password.dirty ||
                      refOld_Password.touched ||
                      refOld_Password.untouched)
                }"
                [(ngModel)]="PasswordModel.Old_Password"
                class="form-control input-text-css"
              />
            </div>
            <div class="col-md-12 p-1">
              <span class="required-lable">New Password</span>
              <input
                type="password"
                name="New_Password "
                id="New_Password "
                #refNew_Password="ngModel"
                required
                placeholder="New Password"
                [ngClass]="{
                  'is-invalid': ddf.submitted && refNew_Password.invalid,
                  'alert-warning':
                    refNew_Password.invalid &&
                    (refNew_Password.dirty ||
                      refNew_Password.touched ||
                      refNew_Password.untouched)
                }"
                [(ngModel)]="PasswordModel.New_Password"
                class="form-control input-text-css"
              />
            </div>
            <div class="col-md-12 p-1">
              <span class="required-lable">Confirm Password</span>
              <input
                type="password"
                name="Confirm_Password "
                id="Confirm_Password "
                #refConfirm_Password="ngModel"
                required
                placeholder="Confirm Password"
                [ngClass]="{
                  'is-invalid': ddf.submitted && refConfirm_Password.invalid,
                  'alert-warning':
                    refConfirm_Password.invalid &&
                    (refConfirm_Password.dirty ||
                      refConfirm_Password.touched ||
                      refConfirm_Password.untouched)
                }"
                [(ngModel)]="PasswordModel.Confirm_Password"
                class="form-control input-text-css"
              />
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            (click)="OnCloseChangePasswordModal()"
            class="btn btn-light font-size-12"
            data-dismiss="modal"
          >
            Cancel
          </button>
          <button
            type="button"
            (click)="onUpdateChangePassword()"
            class="font-size-12 button-btn"
            [disabled]="!ddf.form.valid"
          >
            Update
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
